// An account's oldest API key and oldest switch are its defaults. The API key and
// switch connections take no orderBy, so the oldest is picked client-side from
// one page this size; accounts have only a handful of each.
export const DEFAULT_LOOKUP_SIZE = 100;

type Dated = { insertedAt: Date | string };

export const getOldest = <T extends Dated>(items: readonly T[]): T | null =>
  items.reduce<T | null>(
    (oldest, current) =>
      !oldest || new Date(current.insertedAt) < new Date(oldest.insertedAt) ? current : oldest,
    null
  );
